import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin, clearAuthMessages } from "../redux/slices/authSlice";
import { toast } from "react-toastify";

const SignInLayer = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, loading, error, token } = useSelector((state) => state.auth);

  // Show error message via toast
  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearAuthMessages());
    }
  }, [error, dispatch]);

  // Handle successful login
  useEffect(() => {
    if (user && token) {
      const role = user?.role; // ❤️ FIXED

      if (role === "admin" || role === "sub-admin") {
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", token);
        toast.success("Login Successful!");
        navigate("/");
      } else {
        toast.error("Only Admin or Sub Admin can login here.");
      }
    }
  }, [user, token, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter email & password");
      return;
    }

    dispatch(adminLogin({ email, password })); // ❤️ FIXED
  };

  return (
    <section className="auth bg-base d-flex flex-wrap justify-content-center">
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div className="text-center">
            <Link to="/" className="mb-10 max-w-290-px">
              <img src="assets/images/logo.png" alt="" width={"100%"} height={100} />
            </Link>
            <h5 className="mb-2">Sign In to your Account</h5>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome! Please enter your details
            </p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type="password"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            <button
              type="submit"
              className="btn text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              style={{ backgroundColor: "#f41b3b", color: "#fff" }}
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
